module.exports = __webpack_public_path__ + "img/LogotipoVSF.9b4fdfd0.png";